export enum Catalogues {
  Sales = 'Sales catalogues',
  Semen = 'Semen catalogues',
  IndividualSale = 'individual sale catalogue',
  MyCatalogues = 'Your catalogues',
  MySalesCatalogues = 'Your sales catalogues',
  MySemenCatalogues = 'Your semen catalogues',
  IndividualSemen = 'individual semen catalogue',
}
